module.exports = __webpack_public_path__ + "img/HQ-Z7035-V2-V1-All.b0756b57.jpg";